import { render, staticRenderFns } from "./ClientGoodsList.vue?vue&type=template&id=6a05a132&scoped=true"
import script from "./ClientGoodsList.vue?vue&type=script&lang=js"
export * from "./ClientGoodsList.vue?vue&type=script&lang=js"
import style0 from "./ClientGoodsList.vue?vue&type=style&index=0&id=6a05a132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a05a132",
  null
  
)

export default component.exports